import { Button, ColorV2, Modal, Text } from "@adoptaunabuelo/react-components";
import { ProductScheme, SubscriptionScheme } from "client-v2";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { State } from "../../redux";
import { useEffect, useState } from "react";
import media from "styled-media-query";

const DataView = styled.div`
	display: flex;
	flex-direction: column;
	padding: 28px;
	align-items: center;
	${media.lessThan("medium")`
		padding: 32px 24px;
	`}
`;
const Image = styled.img`
	display: flex;
	height: 232px;
	width: 100%;
	object-fit: cover;
	border-radius: 24px;
	${media.lessThan("medium")`
		padding: 0px;
	`}
`;

const UpdateSubscriptionModal = (props: UpdateSubscriptionModalProps) => {
	const appLocation = useSelector((state: State) => state.location.location);
	const isMobile = useSelector((state: State) => state.screen.isMobile);

	const [currentCurrencyPrice, setCurrentCurrencyPrice] = useState("");
	const [currencyPrice, setCurrencyPrice] = useState("");
	const [type, setType] = useState<"low" | "high">("low");

	useEffect(() => {
		getCurrencyPrice();
		const currentPrice =
			props.subscription.Product.charge === "annually"
				? props.subscription.Product.price / 12
				: props.subscription.Product.charge === "quarterly"
				? props.subscription.Product.price / 3
				: props.subscription.Product.price;
		const newPrice =
			props.product.charge === "annually"
				? props.product.price / 12
				: props.product.charge === "quarterly"
				? props.product.price / 3
				: props.product.price;

		if (newPrice > currentPrice) {
			setType("high");
		} else setType("low");
	}, []);

	const getCurrencyPrice = () => {
		const currency = appLocation
			? appLocation.currency.name.toLocaleUpperCase()
			: "EUR";
		if (props.product.data) {
			const price = props.product.data[currency as any];
			setCurrencyPrice(
				price
					? price.price.toLocaleString("es-ES", {
							useGrouping: true,
					  })
					: props.product.price.toLocaleString("es-ES", {
							useGrouping: true,
					  })
			);
		} else {
			setCurrencyPrice(
				props.product.price.toLocaleString("es-ES", {
					useGrouping: true,
				})
			);
		}
		if (props.subscription.Product.data) {
			const price = props.subscription.Product.data[currency as any];
			setCurrentCurrencyPrice(
				price
					? price.price.toLocaleString("es-ES", {
							useGrouping: true,
					  })
					: props.product.price.toLocaleString("es-ES", {
							useGrouping: true,
					  })
			);
		} else {
			setCurrentCurrencyPrice(
				props.subscription.Product.price.toLocaleString("es-ES", {
					useGrouping: true,
				})
			);
		}
	};

	return (
		<Modal
			isVisible={props.isVisible}
			hideClose={true}
			hideHeader={true}
			type={isMobile ? "full-screen" : "default"}
			style={{ borderRadius: isMobile ? "24px 24px 0px 0px" : 24 }}
			contentStyle={{
				padding: isMobile ? 0 : 4,
				backgroundColor: ColorV2.surface.primaryHard,
			}}
			onClose={props.onClose}
		>
			<Image
				src={
					type === "low"
						? require("../../assets/images/background/update_sub_02.webp")
						: require("../../assets/images/background/update_sub_01.webp")
				}
			/>
			<DataView>
				<Text
					type="h5"
					weight="semibold"
					style={{
						color: "white",
						textAlign: "center",
						border: "2px solid white",
						borderRadius: 4,
						padding: "0px 6px",
						marginBottom: 8,
					}}
				>
					Ya eres embajador
				</Text>
				{type === "high" && (
					<Text
						type="h3"
						weight="semibold"
						style={{
							color: "white",
							textAlign: "center",
							marginBottom: 16,
						}}
					>
						¿Quieres cambiar tu donación a {currencyPrice}{" "}
						{(appLocation ? appLocation.currency.symbol : "€") +
							(props.product.charge === "monthly"
								? " al mes"
								: props.product.charge === "annually"
								? " al año"
								: "")}
						?
					</Text>
				)}
				<Text
					type="p"
					style={{
						color: "white",
						textAlign: "center",
					}}
				>
					{type === "low"
						? `Actualmente tu donación es de ${currentCurrencyPrice} ${
								(appLocation
									? appLocation.currency.symbol
									: "€") +
								(props.product.charge === "monthly"
									? " al mes"
									: props.product.charge === "annually"
									? " al año"
									: "")
						  }. Si quieres aumentar tu donación selecciona otra cantidad.`
						: "Esto nos permitirá acompañar a más personas mayores y mejorar su calidad de vida."}
				</Text>
				{type === "high" && (
					<Text
						type="c2"
						style={{
							color: ColorV2.text.invertHigh,
							textAlign: "center",
							margin: "24px 0px 32px",
						}}
					>
						No se te cobrará nada ahora. El nuevo importe se
						empezará a aplicar en tu próximo recibo.
					</Text>
				)}
				{type === "low" ? (
					<Button
						style={{
							width: "100%",
							marginBottom: 0,
							backgroundColor: "white",
							color: ColorV2.text.primary,
							marginTop: 48,
						}}
						onClick={props.onClose}
					>
						Entendido
					</Button>
				) : (
					<>
						<Button
							style={{ width: "100%", marginBottom: 8 }}
							onClick={props.onSubmit}
						>
							Cambiar donación a {currencyPrice}{" "}
							{(appLocation ? appLocation.currency.symbol : "€") +
								(props.product.charge === "monthly"
									? " al mes"
									: props.product.charge === "annually"
									? " al año"
									: "")}
						</Button>
						<Button
							style={{
								width: "100%",
								justifyContent: "center",
								color: "white",
								border: "1px solid white",
							}}
							design="secondary"
							onClick={props.onClose}
						>
							Mantener mi donación actual
						</Button>
					</>
				)}
			</DataView>
		</Modal>
	);
};
export default UpdateSubscriptionModal;
export interface UpdateSubscriptionModalProps {
	isVisible: boolean;
	subscription: SubscriptionScheme;
	product: ProductScheme;
	onSubmit: () => void;
	onClose: () => void;
}
